import ButtonBorderedSmall from './Buttons/ButtonBorderedSmall';
import ButtonFilledSmall from './Buttons/ButtonFilledSmall';
import { MODEL_STATUSES } from '../../utils/constants';
import { ModelStatuses } from '../../utils/enums';
import { Media } from '../../types/product';
import TablePlainDataCell from './Table/TablePlainDataCell';
import TableTextCell from './Table/TableTextCell';
export interface ProductListCardProps {
    fsn: string;
    modelStatus?: string;
    imageUrl?: string;
    buttontext?: string;
    primaryButtonAction: any;
    secondaryButtonAction: any;
    iconUrl?: string;
    isVendor: boolean;
    medias?: Media[];
    headerData: string[];
}

const ProductListCard = ({ modelStatus, imageUrl, fsn, medias, isVendor, primaryButtonAction, secondaryButtonAction, headerData }: ProductListCardProps) => {
    const disableBtn = modelStatus === ModelStatuses.CREATION_IN_PROGRESS || medias?.length === 0;
    return (
        <tr>
            <TablePlainDataCell dataLabel={headerData[0]}>
                <>{<img src={imageUrl} alt="" className="w-10 h-10 object-contain" />}</>
            </TablePlainDataCell>
            {fsn && <TableTextCell dataLabel={headerData[1]} label={fsn} />}
            <TableTextCell dataLabel={headerData[2]} label={modelStatus && MODEL_STATUSES[modelStatus]} />

            <TablePlainDataCell dataLabel={headerData[0]}>
                <ButtonBorderedSmall fullWidth label={isVendor ? 'Check Feedback' : 'Review Model'} disabled={disableBtn} onClick={secondaryButtonAction} />
            </TablePlainDataCell>
            <TablePlainDataCell dataLabel={headerData[0]}>
                <ButtonFilledSmall fullWidth label={isVendor ? 'Update File' : 'Download Model '} disabled={!isVendor && disableBtn} onClick={primaryButtonAction} />
            </TablePlainDataCell>
        </tr>
    );
};

export default ProductListCard;
